import { render, staticRenderFns } from "./model-field.vue?vue&type=template&id=b744e8fc&"
import script from "./model-field.vue?vue&type=script&lang=js&"
export * from "./model-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b744e8fc')) {
      api.createRecord('b744e8fc', component.options)
    } else {
      api.reload('b744e8fc', component.options)
    }
    module.hot.accept("./model-field.vue?vue&type=template&id=b744e8fc&", function () {
      api.rerender('b744e8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/model-field.vue"
export default component.exports